import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '../../../../../app/common/common.action';
import AdicionarLaminaPage from './adicionar-lamina.page';
import HistologiaApi from '../../histologia.api'
import UteisHistologia from '../../../laminas/laminas.util';
import { getUsuarioLocalStorage } from '../../../../../localStorage.util';

class AdicionarLaminaContainer extends Component {
    constructor(props) {
        super(props)
        this.usuario = getUsuarioLocalStorage();
        this.nrExameRef = React.createRef();
        this.state = {
            tipoLaminaBloco: null,
            laminasSelecionadas: UteisHistologia.getInicialLaminas(),
            tecnicoSelecionado: null,
            tecnicoModalSelecionado: null,
            medicoSelecionado: null,
            complemento: "",
            blocos: [],
            bloco: null,
            nrExame: ''
        }
    }

    componentDidMount() {
        let medico = null;

        if (this.props.medicoPadrao !== null) {
            let encontrouMedico = this.props.medicos.find(el => el.value === this.props.medicoPadrao);
            if (encontrouMedico) {
                medico = encontrouMedico;
            }
        }

        this.setState({
            medicoSelecionado: medico,
            tecnicoModalSelecionado: {
                label: this.usuario.usuarioId + ' - ' + this.usuario.usuario,
                value: this.usuario.usuarioId
            }
        });
        this.nrExameRef.current.focus();
    }

    adicionarLaminas() {
        let laminas = Object.assign(this.state.laminasSelecionadas);
        laminas.push({ lamina: this.state.tipoLaminaBloco.nome, qtd: this.state.tipoLaminaBloco.qtd });
        this.criarLamina(
            laminas,
            this.state.tecnicoModalSelecionado,
            this.state.medicoSelecionado,
            this.state.complemento,
        )

    }

    criarLamina(laminas, tecnico, patologia, complemento) {

        complemento = complemento.trim();
        if (complemento && complemento.length) {
            complemento = " " + complemento + " ";
        } else {
            complemento = " ";
        }

        laminas = laminas.map((lm) => {
            if (!lm.qtd) {
                lm.qtd = 0;
            } else {
                lm.qtd = parseInt(lm.qtd, 10);
            }
            return lm;
        })

        let { bloco } = this.state;

        var data = {
            nrBloco: bloco.label,
            blocoID: bloco.value,
            laudoID: bloco.laudo,
            medicoID: patologia ? patologia.value : null,
            tecnicoID: tecnico ? tecnico.value : null,
            sentinelaMama: false,
            sentinelaMelanoma: false,
            complemento: complemento,
            laminas: laminas,
        }

        HistologiaApi.criarLamina(data).then((result) => {
            this.props.toggle();
            this.props.commonActions.showAlerta("sucesso", `${ this.props.intl.formatMessage({id:"dashboards.histology.bladeSuccessfullyRequested"}) }`, 800);
        }).catch((error) => {
            this.props.toggle();
            this.props.commonActions.showAlerta("error", `${ this.props.intl.formatMessage({id:'dashboards.histology.errorWritingBlades'}) }`, 800);
        });

    }

    quantidadeLaminas(texto) {
        let lamina = this.state.laminasSelecionadas.find(e => e.lamina === texto);
        return lamina.qtd;
    }

    adicionarLaminaNoState(elemento, quantidade) {
        if (elemento) {
            let laminas = [...this.state.laminasSelecionadas]
            laminas = laminas.map((e) => {
                if (e.lamina === elemento) {
                    e.qtd += quantidade;
                    if (e.qtd < 0) {
                        e.qtd = 0;
                    }
                }
                return e;
            });
            this.setState({ laminasSelecionadas: laminas })
        } else {
            var tipoLaminaBloco = this.state.tipoLaminaBloco;
            tipoLaminaBloco.qtd += quantidade;
            if (tipoLaminaBloco.qtd < 0) {
                tipoLaminaBloco.qtd = 0;
            }
            this.setState({ tipoLaminaBloco });
        }

    }

    updateQtdLamina(elemento, quantidade) {
        if (elemento) {
            let laminas = [...this.state.laminasSelecionadas]
            laminas = laminas.map((e) => {
                if (e.lamina === elemento) {
                    e.qtd = quantidade;
                }
                if (e.qtd < 0) {
                    e.qtd = 0;
                }
                return e;
            });
            this.setState({ laminasSelecionadas: laminas })
        } else {
            var tipoLaminaBloco = this.state.tipoLaminaBloco;
            tipoLaminaBloco.qtd = quantidade;
            this.setState({ tipoLaminaBloco });
        }
    }

    onChangeComplemento(event) {
        this.setState({
            complemento: event.currentTarget.value
        })
    }
    onChangeMedico(medico) {
        this.setState({
            medicoSelecionado: medico,
        })
    }

    onChangeTecnicoModal(tecnico) {
        this.setState({
            tecnicoModalSelecionado: tecnico,
        })
    }

    validarCriacaoLamina() {
        if (
            !this.state.tecnicoModalSelecionado ||
            !this.state.medicoSelecionado ||
            !(
                this.state.tipoLaminaBloco !== null &&
                this.state.tipoLaminaBloco.qtd > 0
            )
        ) {
            return true;
        } else {
            return false;
        }
    }

    onPress(event) {
        if (!(event.charCode >= 48 && event.charCode <= 57)) {
            event.preventDefault();
        }
    }

    onChangeBlocos = (event) => {
        let tipo = UteisHistologia.getTipoLamina(event.tipo, this.props.intl);
        this.setState({ bloco: event, tipoLaminaBloco: tipo });
    };

    onChangeNrExame = (event) => this.setState({ nrExame: event.currentTarget.value });

    onKeyPressNrExame(event) {
        if (event.key === 'Enter') {
            let { nrExame } = this.state;
            this.props.commonActions.showFadeCarregando(true);
            HistologiaApi.obterLaudoBlocosCriarLaminaCito(encodeURIComponent(nrExame)).then((res) => {
                let blocos = res.map(el => (
                    {
                        label: el.nr_Bloco,
                        value: el.idLaudoBloco,
                        tipo: el.ds_Tipo_Bloco,
                        laudo: el.laudo,
                        paciente: el.paciente
                    }));
                this.setState({ blocos });
                this.props.commonActions.showFadeCarregando(false);
            })
        }
    }

    limpar = () => {
        let laminas = [...this.state.laminasSelecionadas]

        laminas = laminas.map((e) => {
            e.qtd = 0;
            return e;
        });

        this.setState({
            tipoLaminaBloco: null,
            tecnicoSelecionado: null,
            tecnicoModalSelecionado: null,
            medicoSelecionado: null,
            complemento: "",
            blocos: [],
            bloco: null,
            nrExame: '',
            laminasSelecionadas: laminas
        })
    }

    render() {
        return <AdicionarLaminaPage
            open={this.props.open}
            toggle={this.props.toggle}
            bloco={this.state.bloco}
            nrExame={this.state.nrExame}
            tecnicos={this.props.tecnicos}
            medicos={this.props.medicos}
            tipoLaminaBloco={this.state.tipoLaminaBloco}
            adicionarLaminas={this.adicionarLaminas.bind(this)}
            criarLamina={this.criarLamina.bind(this)}
            quantidadeLaminas={this.quantidadeLaminas.bind(this)}
            adicionarLaminaNoState={this.adicionarLaminaNoState.bind(this)}
            qtdSentinelaMama={this.quantidadeLaminas('Sentinela Mama')}
            qtdSentinelaMelanoma={this.quantidadeLaminas('Sentinela Melanoma')}
            qtdSentinelaColEspecial={this.quantidadeLaminas('Col. Especial')}
            qtdSentinelaImuno={this.quantidadeLaminas('Imuno')}
            qtdSentinelaRecorte={this.quantidadeLaminas('Recorte')}
            qtdFish={this.quantidadeLaminas('Fish')}
            qtdCish={this.quantidadeLaminas('Cish')}
            onChangeMedico={this.onChangeMedico.bind(this)}
            onChangeTecnicoModal={this.onChangeTecnicoModal.bind(this)}
            tecnicoSelecionado={this.state.tecnicoSelecionado}
            tecnicoModalSelecionado={this.state.tecnicoModalSelecionado}
            medicoSelecionado={this.state.medicoSelecionado}
            onPressInput={this.onPress.bind(this)}
            complemento={this.state.complemento}
            onChangeComplemento={this.onChangeComplemento.bind(this)}
            validarCriacaoLamina={this.validarCriacaoLamina.bind(this)}
            updateQtdLamina={this.updateQtdLamina.bind(this)}
            nrExameRef={this.nrExameRef}
            blocos={this.state.blocos}
            onChangeBlocos={this.onChangeBlocos.bind(this)}
            onKeyPressNrExame={this.onKeyPressNrExame.bind(this)}
            onChangeNrExame={this.onChangeNrExame.bind(this)}
            limpar={this.limpar.bind(this)}
        ></AdicionarLaminaPage>
    }
}

const mapStateToProps = (state) => {
    return {
        mensagem: state.commonReducer.mensagemAlerta,
        timeout: state.commonReducer.timeoutAlerta,
        tipoAlerta: state.commonReducer.tipoAlerta,
        idAlerta: state.commonReducer.idAlerta,
        medicoPadrao: state.commonReducer.medicoPadraoMacroscopia
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdicionarLaminaContainer)


// WEBPACK FOOTER //
// ./src/pages/histologia/common/modais/adicionar-lamina/adicionar-lamina.container.js